






























import { Component } from 'vue-property-decorator';
import CoinInformationCard from '@/components/ViewComponent/Exchange/CoinInformationCard.vue';
import CSideBar from '@/components/Layout/SideBar/CSideBar.vue';
import HasSideDrawerMixin from '@/mixin/Layout/has-side-drawer-mixin';
import Cup0 from '@/assets/icons/cup-0.png';
import Cup1 from '@/assets/icons/cup-1.png';
import Cup2 from '@/assets/icons/cup-2.png';
import Cup3 from '@/assets/icons/cup-3.png';
import { UseService } from '@/services/service';
import MissionExecutionCountService from '@/services/mission-execution-count.service';
import { MissionExecutionCountEntity } from '@/entities/mission-execution-count.entity';

@Component<Mission>({
  components: {
    CoinInformationCard,
    CSideBar,
  },
})
export default class Mission extends HasSideDrawerMixin {
  missionExecutionCount: MissionExecutionCountEntity[] = [];
  Cup0Image = Cup0;
  Cup1Image = Cup1;
  Cup2Image = Cup2;
  Cup3Image = Cup3;

  @UseService(MissionExecutionCountService)
  missionExecutionCountService: MissionExecutionCountService;

  get getImage() {
    if (!this.missionExecutionCount.length) return this.Cup0Image;
    let index = 0;
    this.missionExecutionCount.forEach((item) => {
      if (item.isClearMission) index += 1;
    });
    switch (index) {
      case 1:
        return this.Cup1Image;
      case 2:
        return this.Cup2Image;
      case 3:
        return this.Cup3Image;
      default:
        return this.Cup0Image;
    }
  }

  async fetchData() {
    this.missionExecutionCount = await this.missionExecutionCountService.getManyByMonthAndYear();
  }

  async created() {
    await this.fetchData();
    this.$cheeers.socket.on('mission_result@updated', async () => {
      await this.fetchData();
    });
  }
}
